import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faPercent } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../ModalConversion';
import { SERVICES } from '../constants';

export function AccountServicesModal({ isOpen, onClose, account, onSave, saving, onOpenPercentages }) {
    const [services, setServices] = useState({ dist: false, conv: false, ingram: false, biblio: false });
    const [percentage, setPercentage] = useState('');
    const [accountNumberIngram, setAccountNumberIngram] = useState('');
    const [accountLoginIngram, setAccountLoginIngram] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen && account) {
            const hs = account.hired_services || {};
            setServices({
                dist: hs.dist === '1',
                conv: hs.conv === '1',
                ingram: hs.ingram === '1',
                biblio: hs.biblio === '1',
            });
            setPercentage(hs.percentage ? String(hs.percentage) : '');
            setAccountNumberIngram(account.account_number_ingram || '');
            setAccountLoginIngram(account.account_login_id_ingram || '');
            setError('');
        }
    }, [isOpen, account]);

    const setService = (key, value) => setServices((prev) => ({ ...prev, [key]: value }));

    const handleSubmit = () => {
        setError('');
        if (services.ingram && accountNumberIngram === '') {
            setError('Ingresa el ID de cuenta de Ingram');
            return;
        }
        onSave({
            id_pub: account.id_pub,
            services: {
                dist: services.dist ? '1' : '0',
                conv: services.conv ? '1' : '0',
                ingram: services.ingram ? '1' : '0',
                biblio: services.biblio ? '1' : '0',
            },
            percentage: services.dist ? Number(percentage || 15) : null,
            account_number_ingram: services.ingram ? accountNumberIngram.trim() : '',
            account_login_id_ingram: accountLoginIngram.trim(),
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <div className="p-4">
                <h4 className="text-white mb-1">Servicios de la cuenta</h4>
                <div className="text-white-50 small mb-3">
                    {account ? `${account.pub_name} (${account.prefix})` : ''}
                </div>

                <div className="d-flex flex-wrap gap-4 align-items-center mb-3">
                    {SERVICES.map((s) => (
                        <div className="form-check form-switch d-flex align-items-center" key={s.key}>
                            <input
                                className="form-check-input me-2"
                                type="checkbox"
                                id={`svc_${s.key}`}
                                checked={services[s.key]}
                                onChange={(e) => setService(s.key, e.target.checked)}
                            />
                            <label className="form-check-label text-white" htmlFor={`svc_${s.key}`}>{s.label}</label>
                        </div>
                    ))}
                </div>

                {services.dist && (
                    <div className="mb-3">
                        <label className="form-label text-white-50">Porcentajes de distribución</label>
                        <div className="d-flex align-items-center gap-3">
                            <button
                                type="button"
                                className="btn btn-outline-primary border-primary px-3"
                                onClick={() => onOpenPercentages && onOpenPercentages(account)}
                            >
                                <FontAwesomeIcon icon={faPercent} className="me-1" />
                                Configurar porcentajes
                            </button>
                        </div>
                        <div className="form-text text-white-50 mt-1">Define los % por tienda/cuenta en el módulo de porcentajes.</div>
                    </div>
                )}

                {services.ingram && (
                    <>
                        <div className="mb-3">
                            <label className="form-label text-white-50">ID de cuenta Ingram *</label>
                            <input
                                type="number"
                                className="form-control bg-dark text-white border-secondary py-2"
                                value={accountNumberIngram}
                                onChange={(e) => setAccountNumberIngram(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label text-white-50">Ingram login ID</label>
                            <input
                                type="text"
                                className="form-control bg-dark text-white border-secondary py-2"
                                value={accountLoginIngram}
                                onChange={(e) => setAccountLoginIngram(e.target.value)}
                            />
                        </div>
                    </>
                )}

                {error && <div className="text-danger mb-3">{error}</div>}

                <div className="d-flex justify-content-end gap-3">
                    <button className="btn btn-outline-secondary px-4 rounded-pill" onClick={onClose} disabled={saving}>Cancelar</button>
                    <button className="btn btn-success px-4 rounded-pill" onClick={handleSubmit} disabled={saving}>
                        {saving && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                        Guardar servicios
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default AccountServicesModal;